<template>
    <section class="section-padding bg-white">
            <div>
                <div class="row justify-content-center">
                    <div class="col-lg-6 col-12 col-md-6">
                        <h1 class="section-title-center text-center">Politique de confidentialité</h1>
                        <div class="mt-2 mb-2"><p style="text-align:center">Consulter la politique de confidentialité Ouicsport</p></div>
                    </div>
                </div>
                <div class="row justify-content-center mt-5">
                    <div class="col-12">
                        <p class="CGU-text"><strong>Sécurité et protection des données personnelles</strong></p>

<h3>&nbsp;</h3>

<h3><u>Définitions</u>&nbsp;:</h3>

<p class="CGU-text"><strong>L'Éditeur</strong>&nbsp;: La personne, physique ou morale, qui édite les services de communication au public en ligne.<br>
<strong>Le Site</strong>&nbsp;: L'ensemble des sites, pages Internet et services en ligne proposés par l'Éditeur.<br>
<strong>L'Utilisateur</strong>&nbsp;: La personne utilisant le Site et les services.</p>

<h3>&nbsp;</h3>

<h3>Nature des données collectées</h3>

<p class="CGU-text"><strong>Dans le cadre de l'utilisation des Sites, l'Éditeur est susceptible de collecter les catégories de données suivantes concernant ses Utilisateurs :</strong></p>

<p class="CGU-text">Données d'état-civil, d'identité, d'identification...</p>

<p class="CGU-text">Données de connexion (adresses IP, journaux d'événements...)</p>

<h3>&nbsp;</h3>

<h3>Communication des données personnelles à des tiers</h3>

<p class="CGU-text"><strong>Pas de communication à des tiers&nbsp;</strong><br>
Vos données ne font l'objet d'aucune communication à des tiers. Vous êtes toutefois informés qu'elles pourront être divulguées en application d'une loi, d'un règlement ou en vertu d'une décision d'une autorité réglementaire ou judiciaire compétente.</p>

<h3>&nbsp;</h3>

<h3>Information préalable pour la communication des données personnelles à des tiers en cas de fusion / absorption</h3>

<p class="CGU-text"><strong>Information préalable et possibilité d’opt-out avant et après la fusion / acquisition&nbsp;</strong><br>
Dans le cas où nous prendrions part à une opération de fusion, d’acquisition ou à toute autre forme de cession d’actifs, nous nous engageons à garantir la confidentialité de vos données personnelles et à vous informer avant que celles-ci ne soient transférées ou soumises à de nouvelles règles de confidentialité.</p>

<p class="CGU-text">&nbsp;</p>

<h3>Finalité de la réutilisation des données personnelles collectées</h3>

<p class="CGU-text"><strong>Effectuer les opérations relatives à la gestion des clients concernant&nbsp;</strong></p>

<ul>
	<li>les contrats ; les commandes ; les livraisons ; les factures ; la comptabilité et en particulier la gestion des comptes clients</li>
	<li>un programme de fidélité au sein d'une entité ou plusieurs entités juridiques ;</li>
	<li>le suivi de la relation client tel que la réalisation d'enquêtes de satisfaction, la gestion des réclamations et du service après-vente</li>
	<li>la sélection de clients pour réaliser des études, sondages et tests produits (sauf consentement des personnes concernées recueilli dans les conditions prévues à l’article 6, ces opérations ne doivent pas conduire à l'établissement de profils susceptibles de faire apparaître des données sensibles - origines raciales ou ethniques, opinions philosophiques, politiques, syndicales, religieuses, vie sexuelle ou santé des personnes)</li>
</ul>

<p class="CGU-text">&nbsp;</p>

<p class="CGU-text"><strong>Effectuer des opérations relatives à la prospection&nbsp;</strong></p>

<ul>
	<li>la gestion d'opérations techniques de prospection (ce qui inclut notamment les opérations techniques comme la normalisation, l'enrichissement et la déduplication)</li>
	<li>la sélection de personnes pour réaliser des actions de fidélisation, de prospection, de sondage, de test produit et de promotion. Sauf consentement des personnes concernées recueilli dans les conditions prévues à l'article 6, ces opérations ne doivent pas conduire à l'établissement de profils susceptibles de faire apparaître des données sensibles (origines raciales ou ethniques, opinions philosophiques, politiques, syndicales, religieuses, vie sexuelle ou santé des personnes)</li>
	<li>la réalisation d'opérations de sollicitations</li>
</ul>

<p class="CGU-text">&nbsp;</p>

<p class="CGU-text"><strong>L'élaboration de statistiques commerciales</strong></p>

<p class="CGU-text"><strong>La gestion des demandes de droit d'accès, de rectification et d'opposition</strong></p>

<p class="CGU-text"><strong>La gestion des avis des personnes sur des produits, services ou contenus</strong></p>

<h3>&nbsp;</h3>

<h3>Agrégation des données</h3>

<p class="CGU-text"><strong>Agrégation avec des données non personnelles</strong>&nbsp;<br>
Nous pouvons publier, divulguer et utiliser les informations agrégées (informations relatives à tous nos Utilisateurs ou à des groupes ou catégories spécifiques d'Utilisateurs que nous combinons de manière à ce qu'un Utilisateur individuel ne puisse plus être identifié ou mentionné) et les informations non personnelles à des fins d'analyse du secteur et du marché, de profilage démographique, à des fins promotionnelles et publicitaires et à d'autres fins commerciales.</p>

<p class="CGU-text"><strong>Agrégation avec des données personnelles disponibles sur les comptes sociaux de l'Utilisateur</strong>&nbsp;<br>
Si vous connectez votre compte à un compte d’un autre service afin de faire des envois croisés, ledit service pourra nous communiquer vos informations de profil, de connexion, ainsi que toute autre information dont vous avez autorisé la divulgation. Nous pouvons agréger les informations relatives à tous nos autres Utilisateurs, groupes, comptes, aux données personnelles disponibles sur l’Utilisateur.</p>

<h3>&nbsp;</h3>

<h3>Collecte des données d'identité</h3>

<p class="CGU-text"><strong>Consultation libre&nbsp;</strong><br>
La consultation du Site ne nécessite pas d'inscription ni d'identification préalable. Elle peut s'effectuer sans que vous ne communiquiez de données nominatives vous concernant (nom, prénom, adresse, etc). Nous ne procédons à aucun enregistrement de données nominatives pour la simple consultation du Site.</p>

<h3>&nbsp;</h3>

<h3>Collecte des données d'identification</h3>

<p class="CGU-text"><strong>Utilisation de l'identifiant de l’utilisateur uniquement pour l’accès aux services&nbsp;</strong><br>
Nous utilisons vos identifiants électroniques seulement pour et pendant l'exécution du contrat.</p>

<h3>&nbsp;</h3>

<h3>Collecte des données du terminal</h3>

<p class="CGU-text"><strong>Collecte des données de profilage et des données techniques à des fins de fourniture du service&nbsp;</strong><br>
Certaines des données techniques de votre appareil sont collectées automatiquement par le Site. Ces informations incluent notamment votre adresse IP, fournisseur d'accès à Internet, configuration matérielle, configuration logicielle, type et langue du navigateur... La collecte de ces données est nécessaire à la fourniture des services.</p>

<p class="CGU-text"><strong>Collecte des données techniques à des fins publicitaires, commerciales et statistiques&nbsp;</strong><br>
Les données techniques de votre appareil sont automatiquement collectées et enregistrées par le Site, à des fins publicitaires, commerciales et statistiques. Ces informations nous aident à personnaliser et à améliorer continuellement votre expérience sur notre Site. Nous ne collectons ni ne conservons aucune donnée nominative (nom, prénom, adresse...) éventuellement attachée à une donnée technique. Les données collectées sont susceptibles d’être revendues à des tiers.</p>

<h3>&nbsp;</h3>

<h3>Cookies</h3>

<p class="CGU-text"><strong>Durée de conservation des cookies</strong>&nbsp;<br>
Conformément aux recommandations de la CNIL, la durée maximale de conservation des cookies est de 13 mois au maximum après leur premier dépôt dans le terminal de l'Utilisateur, tout comme la durée de la validité du consentement de l’Utilisateur à l’utilisation de ces cookies. La durée de vie des cookies n’est pas prolongée à chaque visite. Le consentement de l’Utilisateur devra donc être renouvelé à l'issue de ce délai.</p>

<p class="CGU-text"><strong>Finalité cookies</strong><br>
Les cookies peuvent être utilisés pour des fins statistiques notamment pour optimiser les services rendus à l'Utilisateur, à partir du traitement des informations concernant la fréquence d'accès, la personnalisation des pages ainsi que les opérations réalisées et les informations consultées.<br>
Vous êtes informé que l'Éditeur est susceptible de déposer des cookies sur votre terminal. Le cookie enregistre des informations relatives à la navigation sur le service (les pages que vous avez consultées, la date et l'heure de la consultation...) que nous pourrons lire lors de vos visites ultérieures.</p>

<p class="CGU-text"><strong>Droit de l'Utilisateur de refuser les cookies&nbsp;</strong><br>
Vous reconnaissez avoir été informé que l'Éditeur peut avoir recours à des cookies. Si vous ne souhaitez pas que des cookies soient utilisés sur votre terminal, la plupart des navigateurs vous permettent de désactiver les cookies en passant par les options de réglage.</p>

<p class="CGU-text"><strong>Gestion des cookies</strong></p>

<p class="CGU-text">Cookies requérant votre consentement préalable&nbsp;: des cookies de mesures d'audience Analytics, provenant du tiers Google, ont pour finalité de recueillir des statistiques de visites anonymes qui, une fois recoupées avec d'autres données, pourraient être intrusives pour la vie privée des utilisateurs du site.</p>

<table class="table table-bordered">
	<thead>
		<tr>
			<th>Nom</th>
			<th>Description</th>
		</tr>
	</thead>
	<tbody>
		<tr>
			<td>_ga</td>
			<td rowspan="3" style="vertical-align:middle">Cookies servant à Google Analytics pour récupérer certaines de vos informations</td>
		</tr>
		<tr>
			<td>_gat_gtag_UA_144027734_1</td>
		</tr>
		<tr>
			<td>_gid</td>
		</tr>
	</tbody>
</table>

<div class="row">
<div class="col-sm-6">
                                    <button type="button" class="btn btn-success btn-block allow-analytics" disabled="">Autoriser les cookies Google Analytics</button>
                                </div>
                                <div class="col-sm-6">
                                    <button type="button" class="btn btn-danger btn-block disallow-analytics">Interdire les cookies Google Analytics</button>
                                </div>
</div>

<p class="CGU-text">&nbsp;</p>

<h3>&nbsp;</h3>

<h3>Conservation des données techniques</h3>

<p class="CGU-text"><strong>Durée de conservation des données techniques&nbsp;</strong><br>
Les données techniques sont conservées pour la durée strictement nécessaire à la réalisation des finalités visées ci-avant.</p>

<h3>&nbsp;</h3>

<h3>Délai de conservation des données personnelles et d'anonymisation</h3>

<p class="CGU-text"><strong>Conservation des données pendant la durée de la relation contractuelle&nbsp;</strong><br>
Conformément à l'article 6-5° de la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés, les données à caractère personnel faisant l'objet d'un traitement ne sont pas conservées au-delà du temps nécessaire à l'exécution des obligations définies lors de la conclusion du contrat ou de la durée prédéfinie de la relation contractuelle.</p>

<p class="CGU-text"><strong>Conservation des données anonymisées au delà de la relation contractuelle / après la suppression du compte&nbsp;</strong><br>
Nous conservons les données personnelles pour la durée strictement nécessaire à la réalisation des finalités décrites dans les présentes CGU. Au-delà de cette durée, elles seront anonymisées et conservées à des fins exclusivement statistiques et ne donneront lieu à aucune exploitation, de quelque nature que ce soit.</p>

<p class="CGU-text"><strong>Suppression des données après suppression du compte&nbsp;</strong><br>
Des moyens de purge de données sont mis en place afin d'en prévoir la suppression effective dès lors que la durée de conservation ou d'archivage nécessaire à l'accomplissement des finalités déterminées ou imposées est atteinte. Conformément à la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés, vous disposez par ailleurs d'un droit de suppression sur vos données que vous pouvez exercer à tout moment en prenant contact avec l'Éditeur.</p>

<p class="CGU-text"><strong>Suppression des données après 3 ans d'inactivité&nbsp;</strong><br>
Pour des raisons de sécurité, si vous ne vous êtes pas authentifié sur le Site pendant une période de trois ans, vous recevrez un e-mail vous invitant à vous connecter dans les plus brefs délais, sans quoi vos données seront supprimées de nos bases de données.</p>

<h3>&nbsp;</h3>

<h3>Suppression du compte</h3>

<p class="CGU-text"><strong>Suppression du compte à la demande&nbsp;</strong><br>
L'Utilisateur a la possibilité de supprimer son Compte à tout moment, par simple demande à l'Éditeur OU par le menu de suppression de Compte présent dans les paramètres du Compte le cas échéant.</p>

<p class="CGU-text"><strong>Suppression du compte en cas de violation des CGU&nbsp;</strong><br>
En cas de violation d'une ou de plusieurs dispositions des CGU ou de tout autre document incorporé aux présentes par référence, l'Éditeur se réserve le droit de mettre fin ou restreindre sans aucun avertissement préalable et à sa seule discrétion, votre usage et accès aux services, à votre compte et à tous les Sites.</p>

<h3>&nbsp;</h3>

<h3>Indications en cas de faille de sécurité décelée par l'Éditeur</h3>

<p class="CGU-text"><strong>Information de l'Utilisateur en cas de faille de sécurité&nbsp;</strong><br>
Nous nous engageons à mettre en oeuvre toutes les mesures techniques et organisationnelles appropriées afin de garantir un niveau de sécurité adapté au regard des risques d'accès accidentels, non autorisés ou illégaux, de divulgation, d'altération, de perte ou encore de destruction des données personnelles vous concernant. Dans l'éventualité où nous prendrions connaissance d'un accès illégal aux données personnelles vous concernant stockées sur nos serveurs ou ceux de nos prestataires, ou d'un accès non autorisé ayant pour conséquence la réalisation des risques identifiés ci-dessus, nous nous engageons à :</p>

<ul>
	<li>Vous notifier l'incident dans les plus brefs délais ;</li>
	<li>Examiner les causes de l'incident et vous en informer ;</li>
	<li>Prendre les mesures nécessaires dans la limite du raisonnable afin d'amoindrir les effets négatifs et préjudices pouvant résulter dudit incident</li>
</ul>

<p class="CGU-text">&nbsp;</p>

<p class="CGU-text"><strong>Limitation de la responsabilité&nbsp;</strong><br>
En aucun cas les engagements définis au point ci-dessus relatifs à la notification en cas de faille de sécurité ne peuvent être assimilés à une quelconque reconnaissance de faute ou de responsabilité quant à la survenance de l'incident en question.</p>

<h3>&nbsp;</h3>

<h3>Transfert des données personnelles à l'étranger</h3>

<p class="CGU-text"><strong>Pas de transfert en dehors de l'Union européenne&nbsp;</strong><br>
L'Éditeur s'engage à ne pas transférer les données personnelles de ses Utilisateurs en dehors de l'Union européenne.</p>

<h3>&nbsp;</h3>

<h3>Modification des CGU et de la politique de confidentialité</h3>

<p class="CGU-text"><strong>En cas de modification des présentes CGU, engagement de ne pas baisser le niveau de confidentialité de manière substantielle sans l'information préalable des personnes concernées&nbsp;</strong><br>
Nous nous engageons à vous informer en cas de modification substantielle des présentes CGU, et à ne pas baisser le niveau de confidentialité de vos données de manière substantielle sans vous en informer et obtenir votre consentement.</p>

<h3>&nbsp;</h3>

<h3>Droit applicable et modalités de recours</h3>

<p class="CGU-text"><strong>Clause d'arbitrage&nbsp;</strong><br>
Vous acceptez expressément que tout litige susceptible de naître du fait des présentes CGU, notamment de son interprétation ou de son exécution, relèvera d'une procédure d'arbitrage soumise au règlement de la plateforme d'arbitrage choisie d'un commun accord, auquel vous adhérerez sans réserve.</p>

<h3>&nbsp;</h3>

<h3>Portabilité des données</h3>

<p class="CGU-text"><strong>Portabilité des données&nbsp;</strong><br>
L'Éditeur s'engage à vous offrir la possibilité de vous faire restituer l'ensemble des données vous concernant sur simple demande. L'Utilisateur se voit ainsi garantir une meilleure maîtrise de ses données, et garde la possibilité de les réutiliser. Ces données devront être fournies dans un format ouvert et aisément réutilisable.</p>
                    </div>
                </div>
            </div>
        </section>

</template>


<script>
export default {
  name: 'politique-de-confidentialite',
}
</script>

<style>
@media (min-width: 992px) {
    .section-padding {
        padding-top: 100px;
        padding-bottom: 100px;
    }
}

.section-padding {
    padding-top: 70px;
    padding-bottom: 70px;
    padding-left:70px;
    padding-right:70px;
}
.bg-white {
    background-color: #fff;
}

.text-center {
    text-align: center !important;
}

.mb-2, .my-2 {
    margin-bottom: .5rem !important;
}
.mt-2, .my-2 {
    margin-top: .5rem !important;
}
.mt-5, .my-5 {
    margin-top: 3rem !important;
}

.section-title-center {
    font-family: inherit;
        font-size: 1rem;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    font-size: 40px;
    line-height: 1.1;
}

@media (min-width: 768px) {
    .CGU-text {
        font-size: 16px;
        line-height: 24px;
    }
}

@media (min-width: 320px) {
    .CGU-text {
        font-size: 14px;
        line-height: 22px;
    }
}
.CGU-text {
    color: #929292;
    font-weight: 400;
    margin-bottom: 0;
}

.table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1.5rem;
  font-family: Arial, sans-serif;
  font-size: 0.95rem;
}

.table th,
.table td {
  padding: 0.75rem;
  text-align: left;
  border: 1px solid #dee2e6;
}

.table thead {
  background-color: #f8f9fa;
}

.table tbody tr:nth-child(odd) {
  background-color: #ffffff;
}

.table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

/* Gestion du rowspan vertical centré */
.table td[rowspan] {
  vertical-align: middle;
}

/* Boutons */
.btn {
  display: block;
  width: 100%;
  padding: 0.6rem 1rem;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  border: none;
  border-radius: 0.25rem;
  transition: background-color 0.2s ease;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Bouton “Autoriser” */
.btn-success {
  background-color: #28a745;
  color: #fff;
}
.btn-success:hover:not(:disabled) {
  background-color: #218838;
}

/* Bouton “Interdire” */
.btn-danger {
  background-color: #dc3545;
  color: #fff;
}
.btn-danger:hover {
  background-color: #c82333;
}

/* Grille simple (2 colonnes à 50%) */
.row {
  display: flex;
  margin: 1rem -0.5rem; /* ajuste l’espacement horizontal */
}
.col-sm-6 {
  flex: 0 0 50%;
  padding: 0 0.5rem;
  box-sizing: border-box;
}

/* ==================== NATIVE APP STYLES ==================== */
body.is-native .section-padding {
  padding: calc(env(safe-area-inset-top) + 16px) 18px calc(24px + env(safe-area-inset-bottom)) 18px !important;
}

body.is-native .section-title-center {
  font-size: 26px !important;
  line-height: 1.25 !important;
  text-align: center !important;
  margin-bottom: 8px;
}

body.is-native .CGU-text {
  font-size: 15px !important;
  line-height: 1.6 !important;
  color: #374151 !important;
  margin-bottom: 10px !important;
}

body.is-native .CGU-text strong {
  color: #111827;
  font-size: 16px;
}

body.is-native h3 {
  font-size: 17px !important;
  color: #111827;
  margin-top: 14px;
  margin-bottom: 6px;
}

body.is-native .row {
  margin: 0;
  flex-wrap: wrap;
}

body.is-native .col-12,
body.is-native .col-lg-6,
body.is-native .col-md-6 {
  width: 100%;
  max-width: 100%;
  padding: 0;
  flex: 0 0 100%;
}

body.is-native .col-sm-6 {
  flex: 0 0 100%;
  padding: 4px 0;
}

body.is-native .table {
  font-size: 13px;
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}

body.is-native .btn {
  height: 48px;
  border-radius: 10px;
  font-size: 16px;
}
</style>

